import mirrorVideoLeft from "../assets/images/icons/mirror-video-left.svg";
import MirrorActivityLayout from "../components/MirrorActivityLayout";
import { useTranslation } from "../components/Localization";

export default function MirrorVideoLeftTaskPage() {
  const { t } = useTranslation();
  return (
    <MirrorActivityLayout
      taskKey="videoLeft"
      step={1}
      progressIcon="bottom-left"
      backTo="/tukorterem/vetites"
      nextTo="/tukorterem/video-jobb"
    >
      <img
        className="mirror-room-diagram"
        src={mirrorVideoLeft}
        alt={t("accessibility.mirrorFirstHalf")}
      />
    </MirrorActivityLayout>
  );
}
